import React from 'react';
import { Box, Typography, Avatar, Chip, Divider } from '@mui/material';
import { CandidateCardProps as Props } from './interface/onboardingInterfaces';

const formatMMDDYYYY = (iso?: string | null) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

const CandidateProfileCard: React.FC<Props> = ({ candidate }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Avatar
          src={candidate.imageUrl}
          sx={{ width: 64, height: 64, mr: 2 }}
        />
        <Box>
          <Typography fontWeight={600} fontSize={17}>
            {candidate.fullName}
          </Typography>
          <Typography fontSize={14} color="text.secondary">
            {candidate.designation}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Candidate Info */}
      <Box>
        <Typography fontSize={14} fontWeight={600}>
          Expected Joining Date
        </Typography>
        <Typography fontSize={14} color="text.secondary" mb={2}>
          {candidate.joiningDate
            ? new Intl.DateTimeFormat('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              }).format(new Date(candidate.joiningDate))
            : ''}
        </Typography>

        <Typography fontSize={14} fontWeight={600}>
          Mobile Number
        </Typography>
        <Typography fontSize={14} color="text.secondary">
          {candidate.contactNo}
        </Typography>
      </Box>
    </Box>
  );
};

export default CandidateProfileCard;
